import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import {
	Avatar,
	Badge,
	Button,
	Chip,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
	useMediaQuery,
} from '@mui/material'
import { getFromStorage, removeFromStorage } from '../utils/storage'
import { currentUserActions, filterByTagActions } from '../redux/store.js'
import MenuIcon from '@mui/icons-material/Menu'
import { useLocation, useNavigate } from 'react-router-dom'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'
import StackedBarChartOutlinedIcon from '@mui/icons-material/StackedBarChartOutlined'
import WarehouseIcon from '@mui/icons-material/Warehouse'
import AnalyticsIcon from '@mui/icons-material/Analytics'
import ScheduleIcon from '@mui/icons-material/Schedule'
import GroupsIcon from '@mui/icons-material/Groups'
import CheckIcon from '@mui/icons-material/Check'
import TableChartIcon from '@mui/icons-material/TableChart'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
// import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
// import AutoAwesomeMotionOutlinedIcon from "@mui/icons-material/AutoAwesomeMotionOutlined";
import MoveUpIcon from '@mui/icons-material/MoveUp'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { DOMAIN, api } from '../utils/api'
import axios from 'axios'
import Search from '../components/SearchInput'
import { useDispatch, useSelector } from 'react-redux'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { handleError } from '../utils/error.js'
import { socket } from '../utils/socket.js'
import { mainGreen, mainRed } from '../utils/color.js'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import { canAccessCashflow } from '../utils/cashflowPermissions.js'

export default function ButtonAppBar() {
	const { tagList, adminStore } = useSelector((state) => state.filterByTag)
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const dispatch = useDispatch()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const navigate = useNavigate()
	const location = useLocation()
	const [guestOrdersQuantity, setGuestOrdersQuantity] = React.useState()
	// const [allGuestOrdersQuantity, setAllGuestOrdersQuantity] = React.useState();
	const [remainingConfirm, setRemainingConfirm] = React.useState()
	const [scheduleOrderQuantity, setScheduleOrderQuantity] = React.useState()
	const [todayOrders, setTodayOrders] = React.useState()
	const [totalOrdersQuantityAndWeight, setTotalOrdersQuantityAndWeight] = React.useState()
	const [copied, setCopied] = React.useState(false)
	const canUseCashflow = canAccessCashflow(currentUser)

	// ------GET FILTER TAG LIST------
	const getFilterTagList = React.useCallback(
		async function () {
			try {
				const response = await axios({
					url:
						currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant'
							? `${DOMAIN}/orders-admin/${adminStore}`
							: api.GET_ORDERS,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				let tagFilter = []
				response.data.forEach((order) => (tagFilter = tagFilter.concat(order.tag)))
				const uniqueTagFilter = [...new Map(tagFilter.map((v) => [v.name, v])).values()]
				const getTagsResponse = await axios({
					url:
						currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant'
							? `${DOMAIN}/storeManager/tags/${adminStore}`
							: `${DOMAIN}/storeManager/tags/${currentUser.store}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				getTagsResponse.data.forEach((tag) => {
					uniqueTagFilter.forEach((item) => {
						if (item.name === tag.name) {
							item.index = tag.index
						}
					})
				})
				dispatch(filterByTagActions.getTagList(uniqueTagFilter))
			} catch (error) {
				handleError(error)
			}
		},
		[token, dispatch, currentUser.store, adminStore, currentUser.role],
	)

	const getGuestOrdersQuantity = React.useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_GUEST_ORDERS_QUANTITY_STORE_MANAGER,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setGuestOrdersQuantity(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token],
	)

	const getConfirmOrdersQuantity = React.useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_CONFIRM_ORDERS_QUANTITY_STORE_MANAGER,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setRemainingConfirm(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token],
	)

	const getScheduleOrderQuantity = React.useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_SCHEDULE_ORDERS_QUANTITY_STORE_MANAGER,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setScheduleOrderQuantity(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token],
	)

	const getTotalOrdersQuantityAndWeight = React.useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_TOTAL_ORDERS,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setTotalOrdersQuantityAndWeight(response.data)
			} catch (err) {
				console.log(err.response.data.message)
			}
		},
		[token],
	)

	React.useEffect(() => {
		if (
			currentUser.isLoggedIn &&
			currentUser.role !== 'director' &&
			currentUser.role !== 'admin' &&
			currentUser.role !== 'assistant'
		) {
			getGuestOrdersQuantity()
			getConfirmOrdersQuantity()
			getScheduleOrderQuantity()
			getTotalOrdersQuantityAndWeight()
		}
	}, [
		getGuestOrdersQuantity,
		getConfirmOrdersQuantity,
		getScheduleOrderQuantity,
		getTotalOrdersQuantityAndWeight,
		currentUser.isLoggedIn,
		currentUser.role,
	])

	// const getAllGuestOrdersQuantity = React.useCallback(
	//   async function () {
	//     try {
	//       const response = await axios({
	//         url: api.GET_ALL_GUEST_ORDERS_QUANTITY,
	//         method: "GET",
	//         headers: {
	//           Authorization: `Bearer ${token}`,
	//         },
	//       });
	//       setAllGuestOrdersQuantity(response.data);
	//     } catch (err) {
	//       console.log(err.response.data.message);
	//     }
	//   },
	//   [token]
	// );

	// React.useEffect(() => {
	//   if (
	//     currentUser.isLoggedIn &&
	//     (currentUser.role === "admin" ||
	//       currentUser.role === "director" ||
	//       currentUser.role === "assistant")
	//   ) {
	//     getAllGuestOrdersQuantity();
	//   }
	// }, [getAllGuestOrdersQuantity, currentUser.isLoggedIn, currentUser.role]);

	React.useEffect(() => {
		const listener = () => {
			new Audio('/audios/createOrderAlarm.mp3').play()
		}
		if (currentUser.role !== 'admin' && currentUser.role !== 'director' && currentUser.role !== 'assistant') {
			socket.on(`create-order-alarm-${currentUser.store}`, listener)
		} else {
			socket.on('create-order-alarm', listener)
		}
		return () => {
			socket.off('create-order-alarm', listener)
			socket.off(`create-order-alarm-${currentUser.store}`, listener)
		}
	})

	const getTodayOrders = React.useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_TODAY_ORDERS,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setTodayOrders(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token],
	)

	React.useEffect(() => {
		if (currentUser.isLoggedIn) {
			getTodayOrders()
		}
	}, [getTodayOrders, currentUser.isLoggedIn])

	//------DRAWER START------

	const [state, setState] = React.useState({
		top: false,
		left: false,
		bottom: false,
		right: false,
	})

	const toggleDrawer = (anchor, open) => (event) => {
		if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return
		}

		setState({ ...state, [anchor]: open })
		if (
			currentUser.isLoggedIn &&
			currentUser.role !== 'director' &&
			currentUser.role !== 'admin' &&
			currentUser.role !== 'assistant'
		) {
			getGuestOrdersQuantity()
			getConfirmOrdersQuantity()
			getScheduleOrderQuantity()
			// getAllGuestOrdersQuantity();
		}
	}

	const list = (anchor) => (
		<Box
			sx={{ 
				width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 280,
				background: 'rgba(255, 255, 255, 0.98)',
				backdropFilter: 'blur(20px)',
				height: '100%',
				borderRight: '2px solid rgba(76, 175, 80, 0.2)',
			}}
			role='presentation'
			onClick={toggleDrawer(anchor, false)}
			onKeyDown={toggleDrawer(anchor, false)}>
			<List>
				{currentUser.isLoggedIn && (
					<ListItem
						onClick={() => {
							navigate('/user/profile')
						}}
						sx={{ 
							background: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
							padding: '24px 16px',
							position: 'relative',
							'&::after': {
								content: '""',
								position: 'absolute',
								bottom: 0,
								left: '50%',
								transform: 'translateX(-50%)',
								width: '70%',
								height: '3px',
								background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
							}
						}}>
						<Avatar 
							sx={{ 
								border: '3px solid rgba(255,255,255,0.4)', 
								cursor: 'pointer',
								width: '55px',
								height: '55px',
								boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
							}} 
							alt='avatar' 
							src={currentUser?.photo} 
						/>
						<Typography sx={{ 
							marginLeft: 2, 
							marginRight: 2, 
							color: '#fff',
							fontWeight: 700,
							fontSize: '17px',
							textShadow: '0 2px 4px rgba(0,0,0,0.3)',
						}}>
							{currentUser?.name}
						</Typography>
						<Box
							sx={{
								display: 'flex',
							}}>
							<Chip 
								size='small' 
								label={currentUser?.roleDescription} 
								sx={{ 
									color: '#fff', 
									background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
									borderRadius: '12px',
									fontWeight: 700,
									boxShadow: '0 4px 12px rgba(255, 107, 107, 0.4)',
									border: '1px solid rgba(255, 255, 255, 0.3)',
								}} 
							/>
						</Box>
					</ListItem>
				)}
				{currentUser.isLoggedIn &&
					currentUser.role !== 'admin' &&
					currentUser.role !== 'director' &&
					currentUser.role !== 'assistant' && (
						<ListItem
							sx={{
								background: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
								padding: '18px 16px',
								position: 'relative',
								'&::after': {
									content: '""',
									position: 'absolute',
									bottom: 0,
									left: '50%',
									transform: 'translateX(-50%)',
									width: '70%',
									height: '2px',
									background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
								}
							}}>
							<Chip 
								size='small' 
								label={currentUser?.storeName} 
								sx={{ 
									color: '#fff', 
									background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
									borderRadius: '12px',
									fontWeight: 700,
									boxShadow: '0 4px 12px rgba(255, 107, 107, 0.4)',
									border: '1px solid rgba(255, 255, 255, 0.3)',
								}} 
							/>
							<Typography
								sx={{
									color: '#fff',
									ml: 2,
									fontSize: 14,
									fontWeight: 700,
									textShadow: '0 2px 4px rgba(0,0,0,0.3)',
								}}>
								{todayOrders?.todayOrdersQuantity}kg | {todayOrders?.orders} đơn
							</Typography>
						</ListItem>
					)}

				{currentUser.isLoggedIn &&
					currentUser.role !== 'director' &&
					currentUser.role !== 'admin' &&
					currentUser.role !== 'assistant' && (
						<Box sx={{ mt: 1, ml: 2 }}>
							<CopyToClipboard
								text={`https://quequan.vn/${currentUser.store}/`}
								onCopy={() => {
									return true
								}}>
								<Button
									variant='contained'
									sx={{
										padding: '2px 10px',
										background: copied ? mainGreen : mainRed,
										'&:hover': { background: copied ? mainGreen : mainRed },
									}}
									size='small'
									onClick={(e) => {
										e.stopPropagation()
										setCopied(true)
									}}>
									{copied ? (
										<>
											<CheckIcon sx={{ fontSize: '18px', mr: 1 }} />
											ĐÃ SAO CHÉP
										</>
									) : (
										<>
											<ContentCopyIcon sx={{ fontSize: '18px', mr: 1 }} />
											LINK ĐẶT HÀNG
										</>
									)}
								</Button>
							</CopyToClipboard>
						</Box>
					)}

				{currentUser.isLoggedIn && currentUser.permission?.includes('manageAllGuestOrder') && (
					<ListItem
						onClick={() => {
							navigate(`/admin/guest-order`)
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<ShoppingCartOutlinedIcon />
							</ListItemIcon>
							<ListItemText primary={'ĐƠN KHÁCH ĐẶT'} />
							{/* {allGuestOrdersQuantity > 0 && (
                  <Typography
                    sx={{
                      color: "#fff",
                      background: mainRed,
                      height: "22px",
                      width: "22px",
                      lineHeight: "22px",
                      textAlign: "center",
                      borderRadius: "50%",
                      fontSize: "14px",
                    }}
                  >
                    {allGuestOrdersQuantity}
                  </Typography>
                )} */}
						</ListItemButton>
					</ListItem>
				)}
				{(currentUser.role === 'director' || currentUser.role === 'admin' || currentUser.role === 'assistant') && (
					<ListItem
						onClick={() => {
							navigate(`/admin/task/store`)
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<DashboardOutlinedIcon />
							</ListItemIcon>
							<ListItemText primary={'QUẢN LÝ CÔNG VIỆC'} />
						</ListItemButton>
					</ListItem>
				)}
				{currentUser.isLoggedIn && currentUser.role === 'admin' && (
					<ListItem
						onClick={() => {
							navigate('/admin/zalo-miniapp')
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<PhoneAndroidIcon />
							</ListItemIcon>
							<ListItemText primary={'ZALO MINI APP'} />
						</ListItemButton>
					</ListItem>
				)}

				{currentUser.isLoggedIn && currentUser.permission?.includes('manageStock') && (
					<ListItem
						onClick={() => {
							if (currentUser.permission?.includes('manageStock')) {
								navigate('/admin/stock')
							}
							if (currentUser.permission?.includes('manageStockByStore')) {
								navigate('/store-manager')
							}
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<WarehouseIcon />
							</ListItemIcon>
							<ListItemText primary={'QUẢN LÝ KHO'} />
						</ListItemButton>
					</ListItem>
				)}

				{currentUser.isLoggedIn && currentUser.permission?.includes('manageBill') && (
					<ListItem
						onClick={() => {
							navigate(`/admin/bill`)
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<RequestQuoteIcon />
							</ListItemIcon>
							<ListItemText primary={'THANH TOÁN ĐƠN HÀNG'} />
						</ListItemButton>
					</ListItem>
				)}

				{currentUser.isLoggedIn && currentUser.permission?.includes('manageGuestOrder') && (
					<ListItem
						onClick={() => {
							navigate(`/store-manager/guest-order`)
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<ShoppingCartOutlinedIcon />
							</ListItemIcon>
							<ListItemText primary={'ĐƠN KHÁCH ĐẶT'} />
							{guestOrdersQuantity > 0 && (
								<Typography
									sx={{
										color: '#fff',
										background: mainRed,
										height: '22px',
										width: '22px',
										lineHeight: '22px',
										textAlign: 'center',
										borderRadius: '50%',
										fontSize: '14px',
									}}>
									{guestOrdersQuantity}
								</Typography>
							)}
						</ListItemButton>
					</ListItem>
				)}

				{currentUser.isLoggedIn &&
					currentUser.role !== 'director' &&
					currentUser.role !== 'admin' &&
					currentUser.role !== 'assistant' &&
					currentUser.permission.includes('updateTransferInfo') && (
						<ListItem
							onClick={() => {
								navigate(`/store-manager/transfer-info`)
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<InfoOutlinedIcon />
								</ListItemIcon>
								<ListItemText primary={'THÔNG TIN CK'} />
							</ListItemButton>
						</ListItem>
					)}

				{currentUser.isLoggedIn &&
					currentUser.role !== 'director' &&
					currentUser.role !== 'admin' &&
					currentUser.role !== 'assistant' && (
						<ListItem
							onClick={() => {
								navigate(`/user/task`)
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<DashboardOutlinedIcon />
								</ListItemIcon>
								<ListItemText primary={'BẢNG LÀM VIỆC'} />
								{totalOrdersQuantityAndWeight?.totalQuantity > 0 && (
									<div
										style={{
											fontSize: '12px',
											fontWeight: 'bold',
											color: mainRed,
										}}>
										<div>{totalOrdersQuantityAndWeight?.totalQuantity} đơn</div>
										<div>{totalOrdersQuantityAndWeight?.totalWeight} kg</div>
									</div>
								)}
							</ListItemButton>
						</ListItem>
					)}

				{currentUser.isLoggedIn &&
					currentUser.role !== 'director' &&
					currentUser.role !== 'admin' &&
					currentUser.role !== 'assistant' &&
					currentUser.role !== 'staff' && (
						<ListItem
							onClick={() => {
								navigate(`/user/internal-sale`)
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<StorefrontOutlinedIcon />
								</ListItemIcon>
								<ListItemText primary={'MUA BÁN NỘI BỘ'} />
							</ListItemButton>
						</ListItem>
					)}

				{/* {currentUser.permission?.includes("manageShippingServiceOrder") && (
          <ListItem
            onClick={() => {
              navigate("/store-manager/shipping-service-order");
            }}
          >
            <ListItemButton sx={{ paddingLeft: 0 }}>
              <ListItemIcon sx={{ minWidth: "40px" }}>
                <AutoAwesomeMotionOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary={"XỬ LÝ GIAO HÀNG"} />
            </ListItemButton>
          </ListItem>
        )} */}

				{currentUser.isLoggedIn && currentUser.permission?.includes('manageStockByStore') && (
					<ListItem
						onClick={() => {
							if (currentUser.permission?.includes('manageStock')) {
								navigate('/warehouse-management')
							}
							if (currentUser.permission?.includes('manageStockByStore')) {
								navigate('/store-manager')
							}
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<WarehouseIcon />
							</ListItemIcon>
							<ListItemText primary={'QUẢN LÝ KHO'} />
						</ListItemButton>
					</ListItem>
				)}

				{currentUser.isLoggedIn &&
					(currentUser.permission?.includes('confirmCheckStock') ||
						currentUser.permission?.includes('confirmReImportFresh') ||
						currentUser.permission?.includes('confirmReImportCooked') ||
						currentUser.permission?.includes('confirmSellExport')) && (
						<ListItem
							onClick={() => {
								navigate('/store-manager/stock/confirm')
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<CheckIcon />
								</ListItemIcon>
								<ListItemText primary={'DUYỆT ĐƠN'} />
								{remainingConfirm > 0 && (
									<Typography
										sx={{
											color: '#fff',
											background: mainRed,
											height: '22px',
											width: '22px',
											lineHeight: '22px',
											textAlign: 'center',
											borderRadius: '50%',
											fontSize: '14px',
										}}>
										{remainingConfirm}
									</Typography>
								)}
							</ListItemButton>
						</ListItem>
					)}

				{currentUser.isLoggedIn && (
					<ListItem
						onClick={() => {
							if (currentUser.role === 'director' || currentUser.role === 'admin' || currentUser.role === 'assistant') {
								navigate('/admin/schedule')
							} else {
								navigate(`/user/schedule/store/${currentUser.store}`)
							}
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<ScheduleIcon />
							</ListItemIcon>
							<ListItemText primary={'ĐƠN ĐẶT TRƯỚC'} />
							{scheduleOrderQuantity > 0 && (
								<Typography
									sx={{
										color: '#fff',
										background: mainRed,
										height: '22px',
										width: '22px',
										lineHeight: '22px',
										textAlign: 'center',
										borderRadius: '50%',
										fontSize: '14px',
									}}>
									{scheduleOrderQuantity}
								</Typography>
							)}
						</ListItemButton>
					</ListItem>
				)}

				{(currentUser.role === 'director' || currentUser.role === 'admin') && (
					<>
						<ListItem
							onClick={() => {
								navigate('/admin/users')
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<SupervisorAccountIcon />
								</ListItemIcon>
								<ListItemText primary={'QUẢN LÝ NGƯỜI DÙNG'} />
							</ListItemButton>
						</ListItem>
						<ListItem
							onClick={() => {
								navigate('/admin/stores')
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<StorefrontOutlinedIcon />
								</ListItemIcon>
								<ListItemText primary={'QUẢN LÝ CỬA HÀNG'} />
							</ListItemButton>
						</ListItem>
					</>
				)}
				{currentUser.role === 'admin' && (
					<ListItem
						onClick={() => {
							navigate('/admin/roles')
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<KeyOutlinedIcon />
							</ListItemIcon>
							<ListItemText primary={'PHÂN QUYỀN'} />
						</ListItemButton>
					</ListItem>
				)}
				{currentUser.permission?.includes('createTag') && (
					<ListItem
						onClick={() => {
							if (currentUser.role === 'director' || currentUser.role === 'admin') {
								navigate('/admin/tags')
							} else {
								navigate(`/admin/tag/store/${currentUser?.store}`)
							}
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<LocalOfferOutlinedIcon />
							</ListItemIcon>
							<ListItemText primary={'QUẢN LÝ TAG'} />
						</ListItemButton>
					</ListItem>
				)}
				{currentUser.role === 'storeManager' && (
					<ListItem
						onClick={() => {
							navigate('/store-manager/users')
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<SupervisorAccountIcon />
							</ListItemIcon>
							<ListItemText primary={'QUẢN LÝ NGƯỜI DÙNG'} />
						</ListItemButton>
					</ListItem>
				)}
				{/* {currentUser.permission?.includes("manageShippingService") && (
          <ListItem
            onClick={() => {
              navigate("/store-manager/shipping-service");
            }}
          >
            <ListItemButton sx={{ paddingLeft: 0 }}>
              <ListItemIcon sx={{ minWidth: "40px" }}>
                <HandshakeOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary={"ĐƠN VỊ GIAO HÀNG"} />
            </ListItemButton>
          </ListItem>
        )} */}

				{canUseCashflow && (
					<ListItem
						onClick={() => {
							navigate('/cashflow')
						}}>
						<ListItemButton
							selected={location.pathname === '/cashflow'}
							sx={{
								paddingLeft: 0,
								'&.Mui-selected': {
									backgroundColor: 'rgba(76, 175, 80, 0.12)',
								},
							}}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<AccountBalanceWalletIcon />
							</ListItemIcon>
							<ListItemText primary={'THU CHI'} />
						</ListItemButton>
					</ListItem>
				)}

				{currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') &&
					currentUser.permission.includes('seeAllStoresStatistics') && (
						<ListItem
							onClick={() => {
								navigate('/admin/statistics/today')
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<TableChartIcon />
								</ListItemIcon>
								<ListItemText primary={'THỐNG KÊ ĐƠN HÀNG'} />
							</ListItemButton>
						</ListItem>
					)}
				{currentUser.isLoggedIn &&
					currentUser.role !== 'admin' &&
					currentUser.role !== 'director' &&
					currentUser.role !== 'assistant' &&
					currentUser.permission.includes('seeStatisticsByStore') && (
						<ListItem
							onClick={() => {
								navigate('/store-manager/statistics/today')
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<TableChartIcon />
								</ListItemIcon>
								<ListItemText primary={'THỐNG KÊ ĐƠN HÀNG'} />
							</ListItemButton>
						</ListItem>
					)}

				{currentUser.isLoggedIn &&
					currentUser.permission.includes('transferStore') && (
						<ListItem
							onClick={() => {
								navigate('/store-manager/statistics/transfer-order')
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<MoveUpIcon />
								</ListItemIcon>
								<ListItemText primary={'THỐNG KÊ ĐƠN CHUYỂN'} />
							</ListItemButton>
						</ListItem>
					)}

				{currentUser.isLoggedIn &&
					(currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') &&
					currentUser.permission.includes('seeAllStoresStatistics') && (
						<ListItem
							onClick={() => {
								navigate('/admin/statistics')
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<StackedBarChartOutlinedIcon />
								</ListItemIcon>
								<ListItemText primary={'THỐNG KÊ CỬA HÀNG'} />
							</ListItemButton>
						</ListItem>
					)}
				{currentUser.isLoggedIn &&
					currentUser.role !== 'admin' &&
					currentUser.role !== 'director' &&
					currentUser.role !== 'assistant' &&
					currentUser.permission.includes('seeStatisticsByStore') && (
						<ListItem
							onClick={() => {
								navigate('/store-manager/statistics')
							}}>
							<ListItemButton sx={{ paddingLeft: 0 }}>
								<ListItemIcon sx={{ minWidth: '40px' }}>
									<StackedBarChartOutlinedIcon />
								</ListItemIcon>
								<ListItemText primary={'THỐNG KÊ CỬA HÀNG'} />
							</ListItemButton>
						</ListItem>
					)}
				{currentUser.isLoggedIn && currentUser.permission?.includes('seeRevenue') && (
					<ListItem
						onClick={() => {
							if (currentUser.role !== 'admin' && currentUser.role !== 'director' && currentUser.role !== 'assistant') {
								navigate('/user/statistics')
							} else {
								navigate('/admin/statistics/user')
							}
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<BarChartOutlinedIcon />
							</ListItemIcon>
							<ListItemText primary={'THỐNG KÊ DOANH THU'} />
						</ListItemButton>
					</ListItem>
				)}

				{currentUser.isLoggedIn && currentUser.permission?.includes('seeAllStoresStockStatistics') && (
					<ListItem
						onClick={() => {
							navigate('/admin/stock/statistics')
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<AnalyticsIcon />
							</ListItemIcon>
							<ListItemText primary={'THỐNG KÊ CÁC KHO'} />
						</ListItemButton>
					</ListItem>
				)}

				{currentUser.isLoggedIn && currentUser.permission?.includes('seeStockStatisticsByStore') && (
					<ListItem
						onClick={() => {
							navigate('/store-manager/stock/statistics')
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<AnalyticsIcon />
							</ListItemIcon>
							<ListItemText primary={'THỐNG KÊ KHO HÀNG'} />
						</ListItemButton>
					</ListItem>
				)}
				{currentUser.isLoggedIn && currentUser.permission?.includes('seeStockForecast') && (
					<ListItem
						onClick={() => {
							navigate('/admin/stock/forecast')
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<CalendarMonthIcon />
							</ListItemIcon>
							<ListItemText primary={'DỰ BÁO TỒN KHO'} />
						</ListItemButton>
					</ListItem>
				)}
				{currentUser.isLoggedIn && currentUser.permission?.includes('viewStockHistory') && (
					<ListItem
						onClick={() => {
							navigate('/store-manager/stock/view-history')
						}}>
						<ListItemButton sx={{ paddingLeft: 0 }}>
							<ListItemIcon sx={{ minWidth: '40px' }}>
								<ManageSearchIcon />
							</ListItemIcon>
							<ListItemText primary={'LỊCH SỬ KHO'} />
						</ListItemButton>
					</ListItem>
				)}
			</List>
			<List>
				<ListItem
					onClick={() => {
						removeFromStorage('current-user')
						dispatch(currentUserActions.isLogout())
						navigate('/login')
					}}
					sx={{ 
						background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
						color: '#fff',
						margin: '20px 16px',
						borderRadius: '16px',
						boxShadow: '0 6px 20px rgba(255, 107, 107, 0.4)',
						border: '2px solid rgba(255, 255, 255, 0.3)',
						'&:hover': {
							background: 'linear-gradient(135deg, #FF5252 0%, #FF7043 100%)',
							transform: 'translateY(-3px)',
							boxShadow: '0 10px 30px rgba(255, 107, 107, 0.5)',
							border: '2px solid rgba(255, 255, 255, 0.5)',
						},
						transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
					}}>
					<ListItemButton sx={{ paddingLeft: 0 }}>
						<ListItemIcon sx={{ minWidth: '40px' }}>
							<LogoutOutlinedIcon sx={{ color: '#fff' }} />
						</ListItemIcon>
						<ListItemText 
							primary={'ĐĂNG XUẤT'} 
							sx={{ 
								fontWeight: 700,
								'& .MuiTypography-root': {
									color: '#fff',
									fontWeight: 700,
								}
							}}
						/>
					</ListItemButton>
				</ListItem>
			</List>
		</Box>
	)

	//------DRAWER END------

	return (
		<AppBar
			elevation={0}
			sx={{
				background: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
				backdropFilter: 'blur(20px)',
				borderBottom: '2px solid rgba(255, 255, 255, 0.3)',
				boxShadow: '0 8px 32px rgba(76, 175, 80, 0.25)',
			}}
			position='fixed'>
			<Toolbar
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					minHeight: '64px',
					padding: '0 16px',
				}}>
				{currentUser.isLoggedIn ? (
					<>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								gap: 2,
							}}>
							{!mediaMd && (
								<>
									<IconButton
										size='large'
										edge='start'
										color='inherit'
										aria-label='menu'
										onClick={toggleDrawer('left', true)}
										sx={{
											background: 'rgba(255, 255, 255, 0.25)',
											backdropFilter: 'blur(10px)',
											border: '2px solid rgba(255, 255, 255, 0.4)',
											borderRadius: '12px',
											color: '#4CAF50',
											'&:hover': {
												background: 'rgba(255, 255, 255, 0.35)',
												transform: 'scale(1.05)',
												border: '2px solid rgba(255, 255, 255, 0.6)',
											},
											transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
										}}>
										<MenuIcon />
									</IconButton>
									<Drawer anchor={'left'} open={state['left']} onClose={toggleDrawer('left', false)}>
										{list('left')}
									</Drawer>
								</>
							)}
							<Box sx={{ 
								background: 'rgba(255, 255, 255, 0.25)',
								backdropFilter: 'blur(10px)',
								borderRadius: '12px',
								border: '2px solid rgba(255, 255, 255, 0.4)',
								padding: '6px',
							}}>
								<Search />
							</Box>
							{currentUser.permission?.includes('filterByTag') && (
								<Badge
									badgeContent={tagList?.filter((tag) => tag.check)?.length}
									sx={{
										'& .MuiBadge-badge': {
											color: '#fff',
											background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
											borderRadius: '12px',
											fontWeight: 'bold',
											boxShadow: '0 2px 8px rgba(255, 107, 107, 0.4)',
										},
									}}>
									<IconButton
										sx={{
											background: 'rgba(255, 255, 255, 0.25)',
											backdropFilter: 'blur(10px)',
											border: '2px solid rgba(255, 255, 255, 0.4)',
											borderRadius: '12px',
											color: '#4CAF50',
											'&:hover': {
												background: 'rgba(255, 255, 255, 0.35)',
												transform: 'scale(1.05)',
												border: '2px solid rgba(255, 255, 255, 0.6)',
											},
											transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
										}}
										onClick={() => {
											if (tagList.length === 0) {
												getFilterTagList()
											}
											dispatch(filterByTagActions.toggleFilterByTag())
										}}>
										<FilterAltIcon />
									</IconButton>
								</Badge>
							)}
						</Box>
						{mediaMd &&
							currentUser.isLoggedIn &&
							currentUser.role !== 'admin' &&
							currentUser.role !== 'director' &&
							currentUser.role !== 'assistant' && (
								<Box 
									display='flex' 
									alignItems='center'
									gap={2}
									sx={{
										background: 'rgba(255, 255, 255, 0.25)',
										backdropFilter: 'blur(10px)',
										borderRadius: '16px',
										border: '2px solid rgba(255, 255, 255, 0.4)',
										padding: '10px 18px',
										boxShadow: '0 4px 16px rgba(76, 175, 80, 0.2)',
									}}>
									<Chip
										size='small'
										label={
											<Typography 
												display='flex' 
												alignItems='center'
												sx={{ fontWeight: 700, fontSize: '13px' }}>
												{currentUser?.storeName}
											</Typography>
										}
										sx={{ 
											color: '#fff', 
											background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
											borderRadius: '12px',
											fontWeight: 'bold',
											boxShadow: '0 4px 12px rgba(255, 107, 107, 0.4)',
											border: '1px solid rgba(255, 255, 255, 0.3)',
										}}
									/>
									<Typography 
										display='flex' 
										alignItems='center'
										sx={{
											color: '#4CAF50',
											fontWeight: 700,
											fontSize: '13px',
											textShadow: '0 1px 2px rgba(255,255,255,0.8)',
										}}>
										{todayOrders?.todayOrdersQuantity}kg | {todayOrders?.orders} đơn
									</Typography>
								</Box>
							)}
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}>
							<Avatar
								sx={{
									border: '3px solid rgba(255, 255, 255, 0.5)',
									width: '40px',
									height: '40px',
									cursor: 'pointer',
									background: 'rgba(255, 255, 255, 0.25)',
									backdropFilter: 'blur(10px)',
									boxShadow: '0 6px 20px rgba(76, 175, 80, 0.3)',
									'&:hover': {
										transform: 'scale(1.1)',
										border: '3px solid rgba(255, 255, 255, 0.7)',
										boxShadow: '0 8px 25px rgba(76, 175, 80, 0.4)',
									},
									transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
								}}
								alt='avatar'
								src={currentUser?.photo}
								onClick={() => {
									navigate('/user/profile')
								}}
							/>
						</Box>
					</>
				) : (
					<Box
						id='version-badge'
						sx={{
							display: 'flex',
							alignItems: 'center',
							flexShrink: 0,
							background: 'rgba(255, 255, 255, 0.25)',
							backdropFilter: 'blur(10px)',
							borderRadius: '16px',
							border: '2px solid rgba(255, 255, 255, 0.4)',
							padding: '10px 18px',
							boxShadow: '0 4px 16px rgba(76, 175, 80, 0.2)',
						}}>
						<GroupsIcon 
							sx={{ 
								fontSize: '28px', 
								mr: 1.5, 
								color: '#4CAF50',
								filter: 'drop-shadow(0 2px 4px rgba(76, 175, 80, 0.3))',
							}} 
						/>
						<Typography 
							sx={{
								color: '#4CAF50',
								fontWeight: 700,
								fontSize: '14px',
								textShadow: '0 1px 2px rgba(255,255,255,0.8)',
							}}>
							version 3.2.0
						</Typography>
					</Box>
				)}
			</Toolbar>
		</AppBar>
	)
}
